<template>
  <HXContentCard title="Reporte de Autogestión">
    <div class="p-4">
      <div class="m-0" v-for="item in schema" :key="item.id" id="formFase">
        <div
          class="text-light py-3 pl-1 bg-dark bg-dark-hover border-bottom"
          v-b-toggle="'collapse-' + item.id"
        >
          <i
            :class="`fas fa-caret-${
              item.collapsed ? 'down incline' : 'right'
            } mr-1`"
          ></i>
          <b> {{ item.step + ")" }} {{ item.label }}</b>
        </div>
        <b-collapse
          v-model="item.collapsed"
          visible
          :id="'collapse-' + item.id"
          class="px-4 py-3"
        >
          <div class="row">
            <div
              class="col-12 col-lg-6 mb-2"
              v-for="field in item.fields"
              :key="field.id"
            >
              <label style="line-height: 1.5; text-align: justify">
                {{ field.label }}
              </label>
              <textarea
                v-if="field.type === 'textarea'"
                class="form-control"
                rows="3"
              ></textarea>
              <DropFile
                v-else-if="field.type === 'file'"
                :urlDir="`users/pesv/reporteAutoGestion/`"
                :pathGet="`PesvPasosEvaluacion/GetPesvListaArchivosId/`"
                pathPost="PesvPasosEvaluacion/CreatePesvPasoEvaluacionArchivo"
                :injectData="{}"
                :fileTypes="[
                  'application/pdf',
                  'application/docx',
                  'image/jpeg',
                  'image/png',
                  'image/gif',
                  'application/msword',
                  'application/vnd.ms-excel',
                  'application/vnd.ms-powerpoint',
                  'text/plain',
                  'image/*',
                  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                  'application/vnd.ms-powerpoint',
                  'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
                  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                  'application/vnd.ms-excel',
                ]"
              />
              <input v-else class="form-control" :type="field.type" />
            </div>
          </div>
        </b-collapse>
      </div>
    </div>
  </HXContentCard>
</template>

<script>
import schema from "./schema";
import DropFile from "@/components/helexium/DropFileV2.vue";
export default {
  components: {
    DropFile,
  },
  data() {
    return {
      schema,
    };
  },
};
</script>

<style lang="scss" scoped></style>
